import _ from 'underscore';
import React, { useEffect, useMemo, useReducer } from 'react';
import PropTypes from 'prop-types';

import { useStepListRenderer } from './use-step-list-renderer';
import { getInitialState, stepManagerReducer } from './step-manager-reducer';

export function StepManager(props) {
  const {
    config,
    shouldSave,
    shouldScrollToMe,
    onStatusUpdate,
    onDataChange,
    scrollToExpandedStep,
  } = props;
  const initialState = useMemo(() => getInitialState({ config }), [config]);
  const [state, dispatch] = useReducer(stepManagerReducer, initialState);
  const { dataList, statusList } = state;
  const steps = useStepListRenderer({
    config, dispatch, state, shouldSave, shouldScrollToMe, scrollToExpandedStep,
  });

  const isInitialized = useMemo(() =>
    _.every(statusList, status => status.isInitialized), [statusList]);
  const hasUnsavedChange = useMemo(() =>
    _.any(statusList, status => status.hasUnsavedChange), [statusList]);
  const hasError = useMemo(() =>
    _.any(statusList, status => !_.isEmpty(status.errorString)), [statusList]);

  useEffect(() => {
    onDataChange(dataList);
  }, [dataList, onDataChange]);

  useEffect(() => {
    onStatusUpdate({
      isInitialized,
      hasUnsavedChange,
      hasError,
    });
  }, [hasError, hasUnsavedChange, isInitialized, onStatusUpdate]);

  return (
    <div className="ba-step-manager">
      { steps }
    </div>
  );
}

StepManager.propTypes = {
  config: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  shouldSave: PropTypes.bool.isRequired,
  shouldScrollToMe: PropTypes.bool.isRequired,
  onStatusUpdate: PropTypes.func.isRequired,
  onDataChange: PropTypes.func.isRequired,
  scrollToExpandedStep: PropTypes.bool,
};

StepManager.defaultProps = {
  scrollToExpandedStep: false,
};
